import React from "react";

/** Bootstrap nav family — Nav, NavItem, NavLink. */

export const Nav = ({ navbar = false, tabs = false, className = "", style, children, ...rest }) => {
  const cls = ["nav", navbar && "navbar-nav", tabs && "nav-tabs", className].filter(Boolean).join(" ");
  return (
    <ul className={cls} style={{ listStyle: "none", margin: 0, padding: 0, ...style }} {...rest}>
      {children}
    </ul>
  );
};

export const NavItem = ({ className = "", style, children, ...rest }) => (
  <li className={["nav-item", className].filter(Boolean).join(" ")} style={{ listStyle: "none", ...style }} {...rest}>
    {children}
  </li>
);

/**
 * NavLink — renders an <a> by default. Pass tag={Link} for react-router links.
 * Accepts `to` prop when used with react-router Link.
 */
export const NavLink = ({ tag: Tag = "a", href, to, className = "", style, children, ...rest }) => {
  const cls = ["nav-link", className].filter(Boolean).join(" ");
  const linkProps = Tag === "a" ? { href } : { to };
  return (
    <Tag className={cls} style={style} {...linkProps} {...rest}>
      {children}
    </Tag>
  );
};
